import type { PeriodicCampaignDto } from "../../types/PeriodicCampaignDto";
import type { PeriodicCampaignEntity } from "../../types/PeriodicCampaignEntity";

export const PeriodicCampaignDtoToEntity = ({ ...rest }: Readonly<PeriodicCampaignDto>): PeriodicCampaignEntity => {
    return { ...rest };
};
